import { Routes } from '@angular/router';
import { EmbedExampleComponent } from './pages/embed-example/embed-example.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'embed/example',
    pathMatch: 'full',
  },
  {
    path: 'embed',
    children: [
      {
        path: 'example',
        component: EmbedExampleComponent,
      },
      {
        path: 'user-numbers',
        loadChildren: () =>
          import('./features/user-numbers/user-numbers.routes').then((m) => m.USER_NUMBERS_ROUTES),
      },
      {
        path: 'user-cards',
        loadChildren: () =>
          import('./features/user-cards/user-cards.routes').then((m) => m.USER_CARDS_ROUTES),
      },
      {
        path: 'user-historical',
        loadChildren: () =>
          import('./features/user-historical/user-historical.routes').then(
            (m) => m.USER_HISTORICAL_ROUTES
          ),
      },
      {
        path: 'sim-replacement',
        loadChildren: () =>
          import('./features/sim-replacement/sim-replacement.routes').then(
            (m) => m.SIM_REPLACEMENT_ROUTES
          ),
      },
      {
        path: 'sim-swap',
        loadChildren: () =>
          import('./features/esim-swap/esim-swap.routes').then((m) => m.ESIM_SWAP_ROUTES),
      },
      {
        path: 'automatic-debit',
        loadChildren: () =>
          import('./features/automatic-debit/automatic-debit.routes').then(
            (m) => m.AUTOMATIC_DEBIT_ROUTES
          ),
      },
      {
        path: 'pqr',
        loadChildren: () => import('./features/pqr/pqr.routes').then((m) => m.PQR_ROUTES),
      },
      {
        path: 'faq',
        loadChildren: () => import('./features/faq/faq.routes').then((m) => m.FAQ_ROUTES),
      },
      {
        path: 'user-resources',
        loadChildren: () =>
          import('./features/user-resources/user-resources.routes').then(
            (m) => m.USER_RESOURCES_ROUTES
          ),
      },
      {
        path: 'mi-parche',
        loadChildren: () =>
          import('./features/mi-parche/mi-parche.routes').then((m) => m.MI_PARCHE_ROUTES),
      },
    ],
  },
];
